export default "__VITE_ASSET__BItPCHdk__"